import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

function parseJwtPayload(token) {
  try {
    const parts = (token || '').split('.')
    if (parts.length < 2) return null
    let base64 = parts[1].replace(/-/g, '+').replace(/_/g, '/')
    // padding
    while (base64.length % 4 !== 0) base64 += '='
    const json = decodeURIComponent(
      atob(base64)
        .split('')
        .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    )
    return JSON.parse(json)
  } catch (e) {
    return null
  }
}

function isJwtExpired(token) {
  const payload = parseJwtPayload(token)
  if (!payload || !payload.exp) return false
  const nowSec = Math.floor(Date.now() / 1000)
  // 提前 5 秒判定过期，避免临界点抖动
  return payload.exp <= (nowSec + 5)
}

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import(/* webpackChunkName: "login" */ '../views/Login.vue')
  },
  {
    path: '/',
    redirect: '/dashboard'
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: () => import(/* webpackChunkName: "dashboard" */ '../views/Dashboard.vue'),
    meta: { requiresAuth: true }
  }
]

const router = new VueRouter({
  mode: 'hash',
  routes
})

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token')
  
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!token) {
      next('/login')
    } else if (isJwtExpired(token)) {
      // Token 过期：自动退出到登录页
      localStorage.removeItem('token')
      next('/login')
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router
